<template>
  <div id="currency">
    <div class="row mt-md-5 text-center">
      <div class="col-md-12 title-image">
        <img src="/static/images/currency/1.jpg" class="img-fluid" alt="パンダくんがどんぐりを集めてる画像">
      </div>
      <div class="col-md-12 text-left">
        <p class="copy">どんぐりは、おひさまキッチンのどうぶつさんたちが お金としてつかっています。</p>
        <br>
      </div>
      <div class="col-md-12 text-left mb-5">
        <p>たとえば、おひさまいちばで、</p>
      </div>
      <div class="col-md-12">
        <img src="/static/images/currency/2.jpg" class="img-fluid" alt="きたかぜのドリンクの画像">
      </div>
      <div class="col-md-12 text-left mb-5">
        <p>きたかぜさんが売っている きたかぜのドリンクは、3どんぐり。</p>
      </div>
      <div class="col-md-12">
        <img src="/static/images/currency/3.jpg" class="img-fluid" alt="雨やのアメの画像">
      </div>
      <div class="col-md-12 text-left mb-5">
        <p>雨やのアメは、ひとつぶ1どんぐり。</p>
      </div>
      <div class="col-md-12">
        <img src="/static/images/currency/4.jpg" class="img-fluid" alt="からくちクモさんのわたがしの画像">
      </div>
      <div class="col-md-12 text-left mb-5">
        <p>からくちクモさんのわたがしは、３どんぐり。</p>
        <p>というふうになっています。</p>
      </div>
      <div class="col-md-12 text-left mb-5">
        <p class="copy">ときどき、新しい絵本が発売されたり、大きなお祭りが あったりすると、どうぶつさんたちの好意により、 どんぐりで、実際に絵本が買えたりします。</p>
      </div>
      <div class="col-md-12 text-left mb-5">
        <p>1冊目の「パンダくん いそいで」</p>
        <p>2冊目の「パンダくん プレゼントのもりへ」</p>
        <p>の発売記念で、どんぐりで絵本を購入したお客様が計400人以上もいらっしゃいました。<router-link v-b-toggle.collapse-1 to="/campaign/archive/2017_donguri.html">→くわしくはこちら</router-link></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    title: "どんぐり通貨",
    data() {
      return {}
    },
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Currency.vue